// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"42a4e51a","203":"59ee0685","234":"ea12af0d","404":"ccea2785","505":"6ef43226","610":"8c322dd5","740":"2df25137","768":"a75b9ed4","837":"752a4533","848":"4a33ca65","965":"df461a71"}[chunkId] + ".chunk.js";
};